// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3_qvM","title":"Header_title__3mYRj","side":"Header_side__zc7yA"};